exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-redirect-button{width:min-content;white-space:nowrap;padding-block:12px;padding-inline:16px;border:1px solid #9ec3cc;border-radius:4px;background-color:#344a5a;color:#9ec3cc;margin-inline:auto}.login-redirect-label{font-size:16px;text-align:center;font-weight:600;margin:0}.show-login{display:flex;flex-direction:column;gap:8px;opacity:1;transition:all .5s ease-in}.hide-login{opacity:0}", ""]);

// exports
